/*  global jQuery, $  */
jQuery(document).ready(function () {
  $('nav#menu').mmenu({
    drag: true,
    pageScroll: {
      scroll: true,
      update: true
    },
    'extensions': [
      'theme-dark',
      'fx-menu-fade',
      'fx-listitems-slide'
    ]
  }, {
    classNames: {
      fixedElements: {
        fixed: 'fix',
        sticky: 'sticky-top'
      }
    }
  })
  $('#pageNavi').sticky({topSpacing: 0})
  $('#pageNavi').on('sticky-end', function () { $(this).parent('.sticky-wrapper').css({height: 'auto'}) }) // sticky 補丁

  $().UItoTop({ easingType: 'easeOutQuart', text: '' })
  $('.dropdown-hover').dropdownHover(100)

  $('#heroBanner').slick({
    lazyLoad: 'ondemand', // lazyLoad
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  })
  $('#heroBanner').on('init', function (e, slick) {
    var $firstAnimatingElements = $('div.slider-item[data-slick-index="0"]').find('[data-animation]');
    slickDoAnimae($firstAnimatingElements);
  });
  $('#heroBanner').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
    var $animatingElements = $('div.slider-item[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
    slickDoAnimae($animatingElements);
    var $prevElements = $('div.slider-item[data-slick-index="' + currentSlide + '"]').find('[data-animation]');
    var $prevAnimationType = 'animated ' + $prevElements.data('animation');
    $prevElements.removeClass($prevAnimationType);
  });
  function slickDoAnimae(elements) {
    var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
    elements.each(function () {
      var $this = $(this);
      var $animationDelay = $this.data('delay');
      var $animationType = 'animated ' + $this.data('animation');
      $this.css({
        'animation-delay': $animationDelay,
        '-webkit-animation-delay': $animationDelay
      });
      $this.addClass($animationType).one(animationEndEvents, function () {
        $this.removeClass($animationType);
      });
    });
  }

  $('#serviceSlider').slick({
    dots: false,
    speed: 600,
    slidesToShow: 3,
    centerMode: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  })

  $('#masseurSlider').slick({
    dots: true,
    speed: 600,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 468,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  })



  $('.lazy').Lazy()







});
